module.exports = __webpack_public_path__ + "img/felice.d05de870.jpg";